import globalStyle from '@/styles/Global.scss';
import React, {useEffect, useState} from "react";
import Layout from "@/layout/Layout";
import {useHistory, useParams} from "react-router";
import ImageCard from "@/components/ImageCard";
import {getCard} from "@/api/card";
import {Card} from "@/entity/Card";
import AttributeViewer from "@/components/AttributeViewer";
import MButton from "@/components/atom/MButton";

const WatashiCard = () => {
  const history = useHistory()
  const {id} = useParams()
  const [card, setCard] = useState(new Card({}))

  useEffect(() => {
    (async () => {
      const card = await getCard({id})
      setCard(card)
    })()
  }, [id])

  const toEdit = () => {
    history.push(`/watashi/${id}/edit`)
  }

  const toBack = () => {
    history.push(`/card`)
  }

  const toQR = () => {
    history.push(`/watashi/${id}/qr`)
  }

  return (
    <>
      <Layout category={'WA'}>
        <div className={globalStyle.container}>
          <div className={globalStyle.bodyContainer}>
            <div className={globalStyle.body}>
              <div className={globalStyle.centerPanel}>
                <ImageCard id={id}></ImageCard>
                <h3>{ card.name }</h3>
                <AttributeViewer attributes={card.attributes}></AttributeViewer>
              </div>
            </div>
          </div>
          <div className={globalStyle.footerContainer}>
            <div className={globalStyle.footer}>
              <div className={globalStyle.centerPanel}>
                <MButton image={'qr.png'} value={'QR'} onClick={ toQR }></MButton>
                <MButton image={'edit.png'} value={'編集'} onClick={ toEdit }></MButton>
                <MButton image={'back.png'} value={'戻る'} onClick={ toBack }></MButton>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  )
}

export default WatashiCard
